export { DefaultPrivacyLevel, TraceContextInjection, isSampleRate, validateAndBuildConfiguration, serializeConfiguration, } from './configuration';
export { createEndpointBuilder } from './endpointBuilder';
export * from './intakeSites';
export { computeTransportConfiguration } from './transportConfiguration';
//# sourceMappingURL=index.js.map